import { getCurrentToken } from '../utils/auth';

type ArtRequest = { 
    id: string;
    asset_name: string;
    asset_description: string;
};

type ArtResult = { 
    id: string;
    url: string;
    width?: number;
    height?: number;
};

export const autoGenerateGameArt = async ({ req, config }: { req: ArtRequest; config: any; }): Promise<ArtResult> => {
    const startTime = Date.now();

    return new Promise(async (resolve, reject) => {
        try {
            const functionURL = `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/generate-image-2`;
            const authToken = await getCurrentToken();
            
            if (!authToken) {
                throw new Error('Authentication token not available');
            }
            
            // console.log(`Generating art for asset: ${req.asset_name}`);
            
            // Prepare request body
            const requestBody = {
                prompt: `Create the following game art asset: ${req.asset_description}`,
                image: '', // No input image for generation
            };
            
            // Call the generate-image-2 endpoint
            const response = await fetch(functionURL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`
                },
                body: JSON.stringify(requestBody)
            });
            
            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Failed to generate image: ${response.status} ${errorText}`);
            }
            
            const result = await response.json();
            
            // Create result with the same ID as the request
            const artResult = {
                id: req.id,
                url: result.image,
                width: result.width,
                height: result.height
            };
            
            const endTime = Date.now();
            const duration = endTime - startTime;
            // console.log(`Game art generation completed in ${duration}ms`);
            
            // console.log('Game art generation result:', artResult);
            resolve(artResult);
        } catch (error) {
            console.error('Error during game art generation:', error);
            reject(error);
        }
    });
};

    